import { EUserRole } from '~/misc/user/types';

const ROLE_OPTIONS: EUserRole[] = [EUserRole.USER, EUserRole.ADMIN, EUserRole.OWNER];
const DEFAULT_ROLE: EUserRole = EUserRole.USER;

export { ROLE_OPTIONS, DEFAULT_ROLE };
